/*
https://splidejs.com/guides/getting-started/
*/

import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    initializeBlock = function() {

        // sliders
        var splideElements = document.querySelectorAll('.slider .splide');

        if (splideElements.length > 0) {
            splideElements.forEach(function (splideElement) {
                var options = JSON.parse(splideElement.getAttribute('data-splide'));
                var splide = new Splide(splideElement, options);
                
                splide.on( 'pagination:mounted', function (data) {
                    var sliderItems = splideElement.querySelector('.splide__list').children;
                    if( data ) {
                        data.list.classList.add('text-pagination');
                        data.items.forEach( function (item) {
                            paginationLabel = sliderItems[item.page].getAttribute('data-pagination');
                            item.button.textContent = String(paginationLabel);
                        });
                    }
                });
                
                splide.mount();
            });
        }
    }
    
    if( window.acf ) {
        // Initialize dynamic block preview (editor).
        window.acf.addAction( 'render_block_preview/type=slider', initializeBlock );
    } else {
        // Initialize on the frontend.
        initializeBlock();
    }
});